// @flow
export { default } from './GrayBoxes';



// WEBPACK FOOTER //
// ./src/components/common/GrayBoxes/index.js